import api from './index'
import request from '@/utils/request'
/**
 * @description 支付宝子商户导出
 */
export function exportAlipayMechant (data) {
  return request({
    url: `${api.exportAlipayMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询支付宝子商户列表
 */
export function queryAlipayMechant (data) {
  return request({
    url: `${api.queryAlipayMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询Cups商户列表
 */
export function queryCupsMechant (data) {
  return request({
    url: `${api.queryCupsMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description Cups商户导出
 */
export function exportCupsMechant (data) {
  return request({
    url: `${api.exportCupsMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description QRA商户导出
 */
export function exportQRAMechant (data) {
  return request({
    url: `${api.exportQRAMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询QRA商户列表
 */
export function queryQRAMechant (data) {
  return request({
    url: `${api.queryQRAMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description QRC商户导出
 */
export function exportQRCMechant (data) {
  return request({
    url: `${api.exportQRCMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询QRC商户列表
 */
export function queryQRCMechant (data) {
  return request({
    url: `${api.queryQRCMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description wx商户更新授权状态
 */
export function updateWxAuthorizestate (data) {
  return request({
    url: `${api.updateWxAuthorizestate}`,
    method: 'post',
    data
  })
}
/**
 * @description 查询微信子商户列表
 */
export function queryWxMechant (data) {
  return request({
    url: `${api.queryWxMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 微信子商户导出
 */
export function exportWxMechant (data) {
  return request({
    url: `${api.exportWxMechant}`,
    method: 'post',
    data
  })
}
/**
 * @description 微信实名认证进度查询列表
 */
export function scheduleCheckList (data) {
  return request({
    url: `${api.scheduleCheckList}`,
    method: 'post',
    data
  })
}
/**
 * @description 微信商户授权列表
 */
export function subMerchantCheckList (data) {
  return request({
    url: `${api.subMerchantCheckList}`,
    method: 'post',
    data
  })
}
/**
 * @description 撤销申请微信授权
 */
export function cancelApplyWx (data) {
  return request({
    url: `${api.cancelApplyWx}`,
    method: 'post',
    data
  })
}
/**
 * @description 批量或单个提交认证
 */
export function certificateCommit (data) {
  return request({
    url: `${api.certificateCommit}`,
    method: 'post',
    data
  })
}
/**
 * @description 渠道商拓展二维码列表
 */
export function agentChannelList (data) {
  return request({
    url: `${api.agentChannelList}`,
    method: 'post',
    data
  })
}
/**
 * @description 上传渠道商拓展二维码
 */
export function uploadChannelQrCode (data) {
  return request({
    url: `${api.uploadChannelQrCode}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商入网意向调查
 */
export function agentSurvey (data) {
  return request({
    url: `${api.agentSurvey}`,
    method: 'post',
    data
  })
}
/**
 * @description 刷新微信授权状态
 */
export function refreshStatus (data) {
  return request({
    url: `${api.refreshStatus}`,
    method: 'post',
    data
  })
}
